import React, { CSSProperties } from 'react';
import { Card } from 'react-bootstrap';

interface ICardLayout {
    children: React.ReactNode;
    classCard?: string;
    classBody?: string;
    style?: CSSProperties;
}

export default function CardLayout({ children, classCard, classBody, style }: ICardLayout) {
    return (
        <Card style={style} className={classCard}>
            <Card.Body className={classBody}>{children}</Card.Body>
        </Card>
    );
}
